export default __webpack_public_path__ + "static/media/Wojtek.4a228358.svg";